import {Injectable} from '@angular/core';
import * as TitlesActions from './titles.actions';
import {map} from 'rxjs/operators';
import {TitlesPartialState} from './titles.reducer';
import {Actions, createEffect} from '@ngrx/effects';
import {DataPersistence, withCorrelationIdOf} from '@kion/ngrx-helper';
import {Title} from '@kion/data-models';
import {TitleConnectors} from './title.connectors';

@Injectable()
export class TitlesEffects {
  loadAll$ = createEffect(() =>
    this.dataPersistence.fetch(
      TitlesActions.loadAll,
      {
        run: (
          action: ReturnType<typeof TitlesActions.loadAll>
        ) => {
          return this.backend.getAll().pipe(
            map(
              (titles: Title[]) => withCorrelationIdOf(
                action,
                TitlesActions.loadAllSuccess({titles: titles})
              )
            )
          );
        },
        onError: (
          action: ReturnType<typeof TitlesActions.loadAll>,
          error
        ) => {
          console.error('Error', error);
          return withCorrelationIdOf(
            action,
            TitlesActions.loadAllError({error: error})
          );
        }
      }
    )
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<TitlesPartialState>,
    private backend: TitleConnectors
  ) {
  }
}

